import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Http } from '@angular/http';
import { ValidarPage } from "../validar/validar";
import { CarritoPage } from '../carrito/carrito';

@IonicPage()
@Component({
  selector: 'page-factura',
  templateUrl: 'factura.html',
})
export class FacturaPage {
  codigo_fac;
  times = new Date();
  fecha;
  hora
  pago;
  user;
  carrito;
  cantidad = 0;
  precioTotal = 0;
  cargo = 0;
  montoTotal = 0;
  carIten = "";
  isPago;
  language = {};
  constructor(public navCtrl: NavController, public navParams: NavParams, public http: Http) {
    this.http.get('https://ebenlovequickpc.com/i18n/languaje.php?lang='+localStorage.getItem('language')).subscribe((data)=>{
      this.language = data.json();
    })
    this.codigo_fac = Math.floor((Math.random() * 99999999) + 1);
      this.fecha = this.times.getDate()+"/"+(this.times.getMonth()+1)+"/"+this.times.getFullYear();
      this.hora = this.times.getHours()+":"+this.times.getMinutes()+":"+this.times.getSeconds();
      this.user = JSON.parse(localStorage.getItem("user"));
      let params = "codigo_user="+this.user.CODIGO_USER;
      this.pago = {};
      if(this.navParams.data.vista === 'carrito'){
        this.http.get("https://ebenlovequickpc.com/API/factura.php?cl=select&usuario="+this.user.CODIGO_USER).subscribe((data)=>{
          this.pago = data.json()[0];
        })
        this.isPago = false;
      }else{
        this.pago = this.navParams.data;
        this.isPago = true;
      }
      this.http.get("https://ebenlovequickpc.com/API/carrito.php?cl=selectUser&"+params).subscribe((data)=>{
      this.carrito = data.json();
        this.carrito.forEach(element => {
            this.precioTotal = this.precioTotal + parseInt(element.PRECIO);
            this.cantidad += 1;
            this.carIten = this.carIten + "," + element.CODIGO_CAR;
        });
      if(this.pago.METODO_COMPRA == 'Estandar Tres semanas ($10)'){
        this.cargo = 10;
      }else if(this.pago.METODO_COMPRA == 'Dos semanas ($15)'){
          this.cargo = 15;
      }
      this.montoTotal = this.precioTotal + this.cargo;
    });

  }

  ionViewDidLoad() {
  }

  imprimir(){
      //Imprimir
  }

  guardar(){
      let params = 'pago='+this.pago.METODO_PAGO+'&compra='+this.pago.METODO_COMPRA
                    +'&envio='+this.pago.ZONA_ENVIO+'&carrito='+this.carIten
                    +'&usuario='+this.user.CODIGO_USER;
                    console.log(this.navParams.data.vista)
      if(this.navParams.data.vista == 'pago'){
        this.http.get("https://ebenlovequickpc.com/API/factura.php?cl=insert&"+params).subscribe((data)=>{
          console.log(data)
          if (!("Notification" in window)) {
            alert("This browser does not support desktop notification");
          }else {
            Notification.requestPermission(function (permission) {
              if (permission === "granted") {
                var notification = new Notification("COMPLETADO");
              }
            });
          }
          this.navCtrl.setRoot(CarritoPage);
        })
      }else if(this.navParams.data.vista == 'repago'){
        this.http.get("https://ebenlovequickpc.com/API/factura.php?cl=update&"+params).subscribe((data)=>{
          if (!("Notification" in window)) {
            alert("This browser does not support desktop notification");
          }else {
            Notification.requestPermission(function (permission) {
              if (permission === "granted") {
                var notification = new Notification("COMPLETADO");
              }
            });
          }
          this.navCtrl.setRoot(CarritoPage);
        })
      }

    }

    comprobar(){
      this.navCtrl.push(ValidarPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/factura/factura.ts